const MyIngredientItemLoading = () => (
  <div className={`p-3.5 rounded-lg cursor-pointer border relative`}>
    <div className="animate-pulse flex space-x-4">
      <div className="flex-1 space-y-6 py-1">
        <div className="h-3 bg-gray-300 rounded"></div>
        <div className="space-y-3">
          <div className="grid grid-cols-3 gap-4">
            <div className="h-2 bg-gray-200 rounded col-span-2"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default MyIngredientItemLoading
